/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ForgotPassword.css";
import { Link } from "react-router-dom";
import { validLoginEmailDonor } from "../../assets/validators/donorInfo.js";
import { simpleFetch } from "../../restWrapper";
import errorMsg from "../../assets/json/errMsg.json";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { resolveThemeColors } from "../../assets/helper";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.props.location.state,
      ...{
        errMsgs: [],
        fetching: false,
      },
    };
    this._handleChange = (e) => {
      this.setState({
        username: e.target.value,
      });
    };
    this._onNextBtnClick = (e) => {
      const validData = validLoginEmailDonor(this.state, this.props.language);
      this.setState({
        errMsgs: validData.msgs,
      });
      if (!validData.isValid) {
        return false;
      }
      this.setState({
        fetching: true,
      });
      simpleFetch("/donors/forgot", "POST", {
        username: this.state.username,
        language: this.props.language,
      }).then((res) => {
        if (res.status === 204) {
          this.props.history.push({
            pathname: "/ResetPassword",
            state: this.state,
          });
          this.setState({ fetching: false, errMsgs: [] });
          return;
        }
        /*
         * The guard is here because a 204 has no body at all. But an error
         * body is not always `{ message }` either: simpleFetch hands back a
         * plain string when a failed response will not parse as JSON, and the
         * Error itself when the fetch rejects. Falling through to [] on those
         * cleared the loader and returned a blank form — no message, and no
         * sign the reset mail was never sent — so the shared "try again"
         * string stands in rather than nothing.
         */
        const message =
          res.body && res.body.message
            ? res.body.message
            : (errorMsg[this.props.language] || errorMsg.en).fail;
        this.setState({ fetching: false, errMsgs: [message] });
      });
    };
  }

  render() {
    if (this.state.fetching) {
      return <this.props.RenderFullPageLoading />;
    }
    const languageObj = this.props.languageObj;

    const resolved = resolveThemeColors(
      this.props.location.state.color.headerColor,
      this.props.location.state.color.buttonColor
    );
    const originalHeaderStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };
    const backgroundOverrideStyle = {
      background: "#" + resolved.headerColor,
    };
    const textOverrideStyle = {
      color: "#" + resolved.buttonColor,
    };
    /*
    const buttonOverrideStyle = {
      background: '#' + this.props.location.state.color.headerColor,
      color: '#' + this.props.location.state.color.buttonColor
    };
*/
    const logoStyle = this.props.location.state.logoStyle;

    const organizationName = this.props.location.state.organizationName;

    return (
      <div className="ForgotPassword-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="ForgotPassword-prompt">
          <Link to={"/LoginPrompt"}>
            <div className="ForgotPassword-backContainer">
              <div className="ForgotPassword-back">
                <div className="ForgotPassword-backBtn"></div>
                <div className="ForgotPassword-backText">
                  {languageObj.backTxt}
                </div>
              </div>
            </div>
          </Link>

          <div
            className="ForgotPassword-logoContainer"
            style={originalHeaderStyle}
          >
            {logoStyle && (
              <div className="ForgotPassword-logo" style={logoStyle}></div>
            )}
          </div>

          <div className="ForgotPassword-text">{languageObj.text}</div>

          <div className="ForgotPassword-inputFieldContainer">
            <div className="ForgotPassword-inputContainerLeft">
              <input
                type="text"
                onChange={this._handleChange}
                value={this.state.username}
                className="ForgotPassword-inputField"
                placeholder={languageObj.placeholder}
              />
            </div>
            <div className="ForgotPassword-inputContainerRight">
              <div
                onClick={this._onNextBtnClick}
                className="ForgotPassword-nextBtn"
                style={backgroundOverrideStyle}
              >
                <div
                  className="ForgotPassword-nextText"
                  style={textOverrideStyle}
                >
                  {languageObj.submit}
                </div>
              </div>
            </div>
          </div>

          {this.state.errMsgs.map((err) => (
            <div key={err} className="ForgotPassword-errorContainer">
              <div className="ForgotPassword-errorIndicator"></div>
              <div className="ForgotPassword-errorMessage">{err}</div>
            </div>
          ))}

          <div className="ForgotPassword-chin"></div>
        </div>
      </div>
    );
  }
}
ForgotPassword.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};
export default ForgotPassword;
